"use client";
import { createCustomTheme, ThemeColors } from "@/themes/shared/themeFactory";

const darkColors: ThemeColors = {
  primary: "#FF735A",
  primaryFg: "#171513",
  background: "#171717",
  foreground: "#e5e5e5",
  secondary: "#4C434F",
  secondaryFg: "#F4E8E8",
  accent: "#82422b",
  card: "#262626",
  cardFg: "#e6e6eb",
  mutedBg: "#262626",
  mutedFg: "#a3a3a3",
  border: "#2e2e2e",
  input: "#404040",
  destructive: "#EF4444",
  destructiveBg: "#ef444440",
  destructiveFg: "#ffffff",
  error: "#EF4444",
  errorBg: "#ef444440",
  errorFg: "#f4c7c3",
  info: "#2C93E6",
  infoBg: "#2c93e640",
  infoFg: "#b7e7fb",
  success: "#5AC75F",
  successBg: "#5ac75f40",
  successFg: "#cce7cc",
  warning: "#FFD900",
  warningBg: "#ffd90040",
  warningFg: "#E7E3CC",
  linkFg: "#2C93E6",
  linkHoverFg: "#b7e7fb",
  sidebarBg: "#0f0f0f",
  sidebarFg: "#e5e5e5",
  dataPlaneSidebarBg: "#080808",
  appBarBg: "#171717",
  appBarFg: "#e5e5e5",
  tabsBg: "#262626",
  tabsFg: "#F4E8E8",
  tabsInactiveFg: "#a3a3a3",
};

const theme = createCustomTheme("dark", darkColors);

export default theme;
